import React, { useEffect } from 'react'
import AddEmployeeSubMenu from '../../../../app/pages/Employees/componenets/AddEmployee/add-employee-menu/components/AddEmployeeSubMenu'
import { DrawerComponent, MenuComponent, ScrollComponent, ToggleComponent } from '../../../assets/ts/components'

function AsideAddEmployee() {
    useEffect(() => {
        setTimeout(() => {
          MenuComponent.reinitialization()
          DrawerComponent.reinitialization()
          ToggleComponent.reinitialization()
          ScrollComponent.reinitialization()
        },50)
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [])
      return (
        <div
          className='menu menu-column menu-fit menu-rounded menu-title-gray-600 menu-icon-gray-400 menu-state-secondary menu-state-icon-secondary menu-state-bullet-secondary menu-arrow-gray-500 fw-bold fs-5 px-6 my-5 my-lg-0'
          id='kt_aside_menu'
          data-kt-menu='true'
        >
          <div id='kt_aside_menu_wrapper' className='menu-fit'>
            <AddEmployeeSubMenu />
          </div>
        </div>
      )
    }

export default AsideAddEmployee;